import { useState, useEffect } from "react";
import { Loader2, Mail, FileText, Eye, PenLine, DollarSign, MessageSquare, ScanSearch, Sparkles, UserPlus, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";

const B = process.env.REACT_APP_BACKEND_URL;
const ICON = { email: Mail, portal: FileText, view: Eye, sign: PenLine, payment: DollarSign, message: MessageSquare, audit: ScanSearch, plan: Sparkles, lead: UserPlus, account: UserPlus };
const COLOR = { email: "text-blue-600 bg-blue-50", portal: "text-indigo-600 bg-indigo-50", view: "text-amber-600 bg-amber-50", sign: "text-green-700 bg-green-50", payment: "text-green-700 bg-green-50", message: "text-slate-600 bg-slate-100" };

export const ClientHistory = ({ leadId, refreshKey }) => {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { api.get(`/api/webadvisor/leads/${leadId}/history`).then(r => setRows(r.data)).catch(() => setRows([])); }, [leadId, refreshKey]);
  if (!rows) return <Loader2 className="w-5 h-5 animate-spin text-slate-400" />;
  const shown = rows.filter(r => !q || `${r.title} ${r.to} ${r.by} ${r.detail}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div data-testid="client-history">
      <Input value={q} onChange={e => setQ(e.target.value)} placeholder="Search history…" className="mb-3" data-testid="client-history-search" />
      {shown.length === 0 ? <p className="text-sm text-slate-400 text-center py-6">Nothing yet.</p> : (
        <div className="max-h-[520px] overflow-y-auto pl-1 pr-1 pt-1">
        <ol className="relative border-l border-slate-200 ml-3 space-y-4">
          {shown.map((r, i) => {
            const Icon = ICON[r.kind] || FileText;
            return (
              <li key={i} className="ml-5" data-testid={`history-item-${i}`}>
                <span className={`absolute -left-3 flex items-center justify-center w-6 h-6 rounded-full ${COLOR[r.kind] || "text-slate-500 bg-slate-100"}`}><Icon className="w-3.5 h-3.5" /></span>
                <p className="text-sm font-semibold text-slate-900 break-words">{r.title}{r.visible === false && <span className="ml-2 inline-flex items-center gap-1 text-[10px] font-bold uppercase text-slate-500"><EyeOff className="w-3 h-3" />hidden</span>}</p>
                <p className="text-xs text-slate-500 break-words">{new Date(r.at).toLocaleString()}{r.to ? ` · to ${r.to}` : ""}{r.by ? ` · by ${r.by}` : ""}</p>
                {r.detail && <p className="text-xs text-slate-600 mt-0.5 whitespace-pre-line break-words">{r.detail}</p>}
                {r.doc_id && <a href={`${B}/api/documents/${r.doc_id}/file`} target="_blank" rel="noreferrer" className="text-xs font-semibold text-blue-600 hover:underline" data-testid={`history-view-${i}`}>View what was sent</a>}
              </li>
            );
          })}
        </ol>
        </div>
      )}
    </div>
  );
};
